import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { aiGenerateInvoice } from "../api/invoices";
import { toast } from "react-hot-toast";
const EXAMPLES = [
  "Create invoice for React website development for ABC Pvt Ltd, Mumbai. 40 hours at ₹2000/hr. Include 18% GST.",
  "Invoice Ravi Sharma, Bengaluru for 3 months of social media management at ₹15,000/month. Inter-state supply.",
  "Bill TechCorp, Delhi for SEO services: keyword research ₹5000, content writing 10 articles at ₹800 each, link building ₹8000.",
  "Invoice for freelance logo design ₹12,000 and brand guidelines ₹8,000 for StartupX, Pune. 18% GST.",
];

export default function AIGenerate() {
  const navigate = useNavigate();
  const [prompt, setPrompt] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [step, setStep] = useState("input"); // input | generating | done

  const handleGenerate = async () => {
    if (!prompt.trim()) return;
    setError("");
    setLoading(true);
    setStep("generating");
    try {
      const { data } = await aiGenerateInvoice(prompt);
      toast.success("Invoice generated successfully!");
      // console.log("AI RESPONSE:",data);
      navigate(`/invoice/${data.invoice._id}?generated=true`);

    }  catch (err) {
  console.error("AI GENERATE ERROR:", err);
  console.error("SERVER RESPONSE:", err.response?.data);

  if (err.response?.status === 503) {
    setError("AI is busy right now. Please try again in a few seconds.");
  } else {
    setError(
      err.response?.data?.message ||
      err.message ||
      "Generation failed. Try rephrasing."
    );
  }

  setStep("input");
}finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        :root {
          --bg: #f5f4f0; --surface: #fff; --border: #e8e6e0;
          --ink: #1a1a24; --muted: #8a8a9a; --accent: #2d2b69;
          --purple: #7c3aed; --purple-light: #f5f3ff;
        }
        body { font-family: 'Sora', sans-serif; background: var(--bg); color: var(--ink); min-height: 100vh; }
        .page { max-width: 720px; margin: 0 auto; padding: 60px 24px; }
        .back-btn { display: inline-flex; align-items: center; gap: 6px; background: none; border: none; font-family: 'Sora', sans-serif; font-size: 13px; color: var(--muted); cursor: pointer; margin-bottom: 40px; padding: 0; transition: color 0.2s; }
        .back-btn:hover { color: var(--ink); }

        .hero-badge { display: inline-flex; align-items: center; gap: 8px; background: var(--purple-light); border: 1px solid #ddd6fe; border-radius: 999px; padding: 6px 16px; font-size: 12px; font-weight: 600; color: var(--purple); letter-spacing: 0.5px; margin-bottom: 20px; }
        .page-title { font-size: 36px; font-weight: 700; letter-spacing: -1px; margin-bottom: 12px; }
        .page-title span { background: linear-gradient(135deg, var(--purple), var(--accent)); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
        .page-sub { font-size: 15px; color: var(--muted); margin-bottom: 40px; line-height: 1.6; }

        .prompt-card { background: var(--surface); border: 2px solid var(--border); border-radius: 20px; padding: 24px; margin-bottom: 20px; transition: border-color 0.2s; }
        .prompt-card:focus-within { border-color: var(--purple); }
        .prompt-label { font-size: 11px; font-weight: 600; letter-spacing: 1.5px; text-transform: uppercase; color: var(--muted); margin-bottom: 12px; }
        textarea { width: 100%; min-height: 140px; background: transparent; border: none; outline: none; font-family: 'Sora', sans-serif; font-size: 15px; color: var(--ink); resize: vertical; line-height: 1.7; }
        textarea::placeholder { color: #c4c4d4; }
        .prompt-footer { display: flex; align-items: center; justify-content: space-between; margin-top: 16px; padding-top: 16px; border-top: 1px solid var(--border); }
        .char-count { font-size: 11px; color: var(--muted); }

        .btn { display: inline-flex; align-items: center; gap: 8px; padding: 12px 24px; border-radius: 12px; font-family: 'Sora', sans-serif; font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.15s; border: none; }
        .btn-ai { background: linear-gradient(135deg, var(--purple), var(--accent)); color: white; box-shadow: 0 4px 16px rgba(124,58,237,0.3); }
        .btn-ai:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 6px 20px rgba(124,58,237,0.4); }
        .btn-ai:disabled { opacity: 0.6; cursor: not-allowed; }

        /* Examples */
        .examples-title { font-size: 12px; font-weight: 600; letter-spacing: 1px; text-transform: uppercase; color: var(--muted); margin-bottom: 12px; }
        .examples-grid { display: grid; gap: 10px; }
        .example-chip { background: var(--surface); border: 1px solid var(--border); border-radius: 12px; padding: 14px 16px; font-size: 13px; color: var(--ink); cursor: pointer; text-align: left; transition: all 0.15s; font-family: 'Sora', sans-serif; line-height: 1.5; }
        .example-chip:hover { border-color: var(--purple); background: var(--purple-light); color: var(--purple); }
        .example-chip::before { content: '"'; color: var(--purple); font-weight: 700; margin-right: 4px; }

        .error-alert { background: #fee2e2; border: 1px solid #fca5a5; border-radius: 12px; padding: 14px 16px; font-size: 13px; color: #dc2626; margin-bottom: 16px; }

        /* Generating state */
        .generating-state { text-align: center; padding: 60px 24px; }
        .ai-spinner { width: 56px; height: 56px; border: 3px solid #ede9fe; border-top-color: var(--purple); border-radius: 50%; animation: spin 0.8s linear infinite; margin: 0 auto 24px; }
        @keyframes spin { to { transform: rotate(360deg); } }
        .gen-title { font-size: 20px; font-weight: 700; margin-bottom: 8px; }
        .gen-steps { display: flex; flex-direction: column; gap: 8px; max-width: 280px; margin: 24px auto 0; }
        .gen-step { display: flex; align-items: center; gap: 10px; font-size: 13px; color: var(--muted); }
        .gen-dot { width: 8px; height: 8px; border-radius: 50%; background: #ddd6fe; flex-shrink: 0; }
        .gen-dot.active { background: var(--purple); animation: pulse 1s ease infinite; }
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }
      `}</style>

      <div className="page">
        <button className="back-btn" onClick={() => navigate("/dashboard")}>← Back to Dashboard</button>

        {step === "generating" ? (
          <div className="generating-state">
            <div className="ai-spinner" />
            <div className="gen-title">Generating your invoice...</div>
            <p style={{ color: "var(--muted)", fontSize: 14 }}>Claude is reading your description and building a GST-compliant invoice</p>
            <div className="gen-steps">
              {["Parsing your description", "Calculating GST amounts", "Applying CGST/SGST/IGST", "Building invoice"].map((s, i) => (
                <div key={i} className="gen-step">
                  <div className={`gen-dot ${i === 1 ? "active" : ""}`} />
                  {s}
                </div>
              ))}
            </div>
          </div>
        ) : (
          <>
            <div className="hero-badge">✦ Powered by vrsafetech</div>
            <h1 className="page-title">Describe your invoice,<br /><span>we'll build it.</span></h1>
            <p className="page-sub">Tell Claude what services you provided, to whom, and at what rate. It will generate a complete GST-compliant invoice with correct tax calculations.</p>

            {error && <div className="error-alert">⚠ {error}</div>}

            <div className="prompt-card">
              <div className="prompt-label">Your description</div>
              <textarea
                placeholder="e.g. Invoice Priya Mehta, Mumbai for 3 months of content writing at ₹20,000/month. Include 18% GST. Due in 15 days."
                value={prompt}
                onChange={(e) => setPrompt(e.target.value)}
                autoFocus
              />
              <div className="prompt-footer">
                <span className="char-count">{prompt.length} chars</span>
                <button className="btn btn-ai" onClick={handleGenerate} disabled={loading || !prompt.trim()}>
                  ✦ Generate Invoice
                </button>
              </div>
            </div>

            <div>
              <div className="examples-title">Try an example</div>
              <div className="examples-grid">
                {EXAMPLES.map((ex, i) => (
                  <button key={i} className="example-chip" onClick={() => setPrompt(ex)}>
                    {ex}
                  </button>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
